var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"465b7d1796c92ad65a55be51903fd3cf5f76223b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kula@ribbit-lb"]={id:"465b7d1796c92ad65a55be51903fd3cf5f76223b"};
      